import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EndpointService } from './endpoint.service';

@Injectable({
    providedIn: 'root'
})
export class UploadService extends EndpointService {

    constructor(http: HttpClient) {
        super(http);
    }

    getPreSignedURL(fileName: string) {
        return this.http.get(this.getApiUrl('Upload/GetPreSignedURL'), {
            params: new HttpParams().set('key', fileName), responseType: 'text'
        });
    }

    getAssetsPreSignedURL(fileName: string, assetType: number) {
        return this.http.get(this.getApiUrl('Upload/GetAssetsPreSignedURL'), {
            params: new HttpParams().set('key', fileName).set('assetType', assetType),
            responseType: 'text'
        });
    }

    uploadFile(signedUrl: string, file: any) {
        return this.http.put(signedUrl, file, {
            headers: {}, responseType: 'blob',
            withCredentials: false
        });
    }
}